<template>
  <b-row class="mb-2 align-items-center no-gutters">
    <b-col cols="1" class="d-flex justify-content-center">
      <div :class="['dia-circulo', dia.sinOperacion ? 'dia-gris' : 'dia-azul']">
        {{ dia.inicial }}
      </div>
    </b-col>
    <b-col cols="4" class="px-2">
      <div :id="`wrapper-apertura-${dia.idDia}`" class="timepicker-wrapper">
        <TimepickerField
            :id="`timepicker-apertura-${dia.idDia}`"
            :value="dia.apertura"
            @input="$emit('update:apertura', $event)"
            :disabled="disabled || dia.sinOperacion"
            :show-label="false"
            :empty-display="dia.sinOperacion ? '--:--' : null"
        />
      </div>
      <b-tooltip
          :target="`wrapper-apertura-${dia.idDia}`"
          placement="top"
          variant="light"
          v-if="dia.sinOperacion"
      >
        No puedes asignar un horario porque este día está marcado como SIN OPERACIÓN
      </b-tooltip>
    </b-col>
    <b-col cols="4" class="px-2">
      <div :id="`wrapper-cierre-${dia.idDia}`" class="timepicker-wrapper">
        <TimepickerField
            :id="`timepicker-cierre-${dia.idDia}`"
            :value="dia.cierre"
            @input="$emit('update:cierre', $event)"
            :disabled="disabled || dia.sinOperacion"
            :show-label="false"
            :empty-display="dia.sinOperacion ? '--:--' : null"
        />
      </div>
      <b-tooltip
          :target="`wrapper-cierre-${dia.idDia}`"
          placement="top"
          variant="light"
          v-if="dia.sinOperacion"
      >
        No puedes asignar un horario porque este día está marcado como SIN OPERACIÓN
      </b-tooltip>
    </b-col>
    <b-col cols="3" class="d-flex justify-content-center">
      <b-form-checkbox
          :checked="dia.sinOperacion"
          @change="$emit('update:sinOperacion', $event)"
          switch
          size="lg"
          :disabled="disabled"
      ></b-form-checkbox>
    </b-col>
  </b-row>
</template>

<script>
import TimepickerField from './TimepickerField.vue';

export default {
  components: {
    TimepickerField
  },
  props: {
    /** @typedef {Object} DiaHorario
     * @property {number} idDia - ID del día (1=Lunes, 7=Domingo)
     * @property {string} inicial - Primera letra del día
     * @property {Object} apertura - Hora de apertura {HH, mm}
     * @property {Object} cierre - Hora de cierre {HH, mm}
     * @property {boolean} sinOperacion - Si el día no tiene operación */
    /** @type {DiaHorario} */
    dia: {
      type: Object,
      required: true
    },
    /** @type {boolean} Si los controles están deshabilitados */
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.dia-circulo {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.dia-azul { background-color: #008FFF; color: #ffffff; font-weight: 600; }
.dia-gris { background-color: #dee2e6; color: #212529; font-weight: 600; }

::v-deep .tooltip-inner {
  font-size: 14px;
}
</style>